<template>
  <el-dialog v-model="visible" title="图片编辑" width="80%" destroy-on-close >
    <div class="editor-container" style="text-align: center">
      <div >
        <canvas
            ref="canvas"
            @mousedown="startDrawing"
            @mousemove="draw"
            @mouseup="stopDrawing"
            @mouseleave="stopDrawing"
        ></canvas>
      </div>
      <div  style="text-align: center">
        <div style="display: inline-block;">
        <el-button-group  style="margin-right: 10px;float: left">
          <el-button
              @click="setBrush('pen')"
              :type="currentTool === 'pen' ? 'primary' : ''"
          >
            <el-icon><Edit /></el-icon>
          </el-button>
          <el-button

              @click="setBrush('eraser')"
              :type="currentTool === 'eraser' ? 'primary' : ''"
          >
            <el-icon><Delete /></el-icon>
          </el-button>
        </el-button-group>
        <el-slider

            v-model="brushSize"
            :min="1"
            :max="50"
            style="width: 200px;margin-right: 10px;float: left"
        />
        <el-color-picker v-model="brushColor" style="margin-right: 10px" />
        </div>
      </div>
    </div>
    <template #footer>
      <div style="text-align: center">
      <span class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="saveImage">保存</el-button>
      </span>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, computed, watch, nextTick } from "vue";
import { Edit, Delete } from "@element-plus/icons-vue";

const props = defineProps({
  imageUrl: {
    type: String,
    required: true,
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "save"]);

const visible = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
});

const canvas = ref(null);
const ctx = ref(null);
const isDrawing = ref(false);
const brushSize = ref(20);
const brushColor = ref("#000000");
const currentTool = ref("eraser");

// 画布状态
let lastX = 0;
let lastY = 0;

const initCanvas = async () => {
  try {
    const img = new Image();
    /*img.setAttribute('crossOrigin', 'anonymous') //关键*/
    img.src = props.imageUrl;

    img.onload = () => {
      const canvasEl = canvas.value;

      let width =1000;
      let height =img.height*width/img.width;

      canvasEl.width = width;
      canvasEl.height = height;
      ctx.value = canvasEl.getContext("2d");
      ctx.value.drawImage(img, 0, 0,width,height);
    };
  } catch (error) {
    console.error("图片加载失败:", error);
    // 添加错误提示
  }
};

const setBrush = (tool) => {
  currentTool.value = tool;
};

const startDrawing = (e) => {
  isDrawing.value = true;
  [lastX, lastY] = [e.offsetX, e.offsetY];
  console.log(e.offsetX, e.offsetY)
};

const draw = (e) => {
  if (!isDrawing.value || !ctx.value) return;
  console.log(e.offsetX, e.offsetY)
  ctx.value.beginPath();
  ctx.value.moveTo(lastX, lastY);
  ctx.value.lineTo(e.offsetX, e.offsetY);
  ctx.value.strokeStyle =
      currentTool.value === "eraser" ? "#ffffff" : brushColor.value;
  ctx.value.lineWidth = brushSize.value;
  ctx.value.lineCap = "round";
  ctx.value.stroke();

  [lastX, lastY] = [e.offsetX, e.offsetY];
};

const stopDrawing = () => {
  isDrawing.value = false;
};

const saveImage = () => {
  console.log(canvas.value, "canvas.value");
  const imageData = canvas.value.toDataURL("image/png");
  emit("save", imageData);
  visible.value = false;
};

watch(
    () => props.imageUrl,
    () => {
      if (visible.value) {
        initCanvas();
      }
    }
);

watch(visible, (val) => {
  if (val) {
    nextTick(() => {
      initCanvas();
    });
  }
});
</script>

<style scoped>

.editor-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.canvas-container {
  width: 80%;
  overflow: auto;
  border: 1px solid #dcdfe6;
}

.tools {
  display: flex;
  gap: 20px;
  align-items: center;
  padding: 10px;
}

canvas {
  max-width: 100%;
  cursor: crosshair;
}
</style>
